module.exports = __webpack_public_path__ + "img/motors-rotate.4b8f307d.svg";